import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { NAVIGATION, LOGO_URL } from '../mock';

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
      {/* announcement bar */}
      <div className="bg-[#1e1b4b] text-white text-xs md:text-sm py-2 text-center px-4">
        <span className="opacity-90">Door rood rijden = € 310. Wij helpen je gratis bezwaar maken.</span>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Bezwaarmeesters logo" className="h-10 md:h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAVIGATION.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  item.highlight
                    ? 'text-[#f26b1f] hover:text-[#d4581a]'
                    : isActive
                      ? 'text-[#1e1b4b]'
                      : 'text-slate-700 hover:text-[#1e1b4b]'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/indienen">
            <Button size="sm" className="bg-[#f26b1f] hover:bg-[#d4581a] text-white">Gratis indienen</Button>
          </Link>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <nav className="flex flex-col p-4 gap-1">
            {NAVIGATION.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium ${
                    item.highlight ? 'text-[#f26b1f]' : isActive ? 'bg-slate-100 text-[#1e1b4b]' : 'text-slate-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="h-px bg-slate-200 my-2" />
            <Link to="/indienen" onClick={() => setOpen(false)}>
              <Button size="sm" className="bg-[#f26b1f] hover:bg-[#d4581a] text-white w-full">Gratis indienen</Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
